/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Erlang distribution probability density function (PDF).
*
* @module @stdlib/stats/base/dists/erlang/pdf
*
* @example
* import pdf from '@stdlib/stats/base/dists/erlang/pdf';
*
* var y = pdf( 0.5, 2, 2.5 );
* // returns ~0.895
*
* var myPDF = pdf.factory( 6, 7.0 );
* y = myPDF( 7.0 );
* // returns ~8.64e-15
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-nonenumerable-read-only-property';
import main from './main.js';
import factory from './factory.js';


// MAIN //

setReadOnly( main, 'factory', factory );


// EXPORTS //

export default main;
